module.exports = __webpack_public_path__ + "91ea82aae0325423d10c9ac733e5fd6e.MP3";